import React from "react";
import { FaRegFilePdf } from "react-icons/fa";
import PageTitle from "../titles/page-title";

function News() {
  return (
    <div className="content-container">
      <PageTitle title="Oznamy"></PageTitle>
      {/* <p>Žiadne nové oznamy</p> */}
      <div>
          <a
            href={
              process.env.PUBLIC_URL +
              "/pdf/news/Pozvanka_plagat__29-11-2025.pdf"
            }
            target="_blank"
            rel="noreferrer"
          >
            <FaRegFilePdf /> Pozvánka na mimoriadne zasadnutie pozemkového spoločenstva
          </a>
        </div>
    </div>
  );
}

export default News;
